// src/components/Modals/DeleteSeriesModal.jsx
import React from 'react';
import './ModalBase.css';
import { FaTimes } from 'react-icons/fa';

export default function DeleteSeriesModal({ onClose, onConfirm}) {
  return (
    <div className="modal-overlay">
      <div className="modal-window">
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
        <h2 className="modal-title">Удалить серию?</h2>

        <div className="modal-form">
          <p className="modal-delete-text">
            Вы уверены, что хотите удалить выбранную серию?<br/>
            Это действие нельзя будет отменить.
          </p>
        </div>

        <div className="modal-actions">
          <button className="modal-button cancel" onClick={onClose}>
            Отмена
          </button>
          <button className="modal-button delete" onClick={onConfirm}>
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
}
